<div style="max-height: 1080px">
	<sim-dynamic-script #webodfjs src="webodf.modified.min.js" />

	<div #canvasContainer style="text-align: center">
		<div #odfCanvas style="margin-left: auto; margin-right: auto"></div>
	</div>
</div>
